import React from 'react';

import { useMindmap } from '../../../../pages/mindmap/use-mindmap';

export const FormatTextContentMenuLinkingSector = () => {
  const {
    textFormatting: { toggleSelectedTextFormat, selectedTextFormats },
  } = useMindmap();

  const toggleLink = () => toggleSelectedTextFormat({ type: 'link' });

  const toggleStyleTemplate = () => {
    // TODO.
  };

  return (
    <>
      {/* link */}
      <div style={{ gridColumn: '1 / 2', gridRow: '1 / 2' }} onClick={toggleLink}>
        <i className={`context-menu-icon pi ri-link ${selectedTextFormats?.link.link ? 'enabled' : ''}`}></i>
      </div>
      {/* style-template */}
      <div style={{ gridColumn: '1 / 2', gridRow: '2 / 3' }} onClick={toggleStyleTemplate}>
        <i className="context-menu-icon pi ri-paint-brush-line "></i>
      </div>
    </>
  );
};
